// 发票详细信息页面
<template>
    <div class="main-center" style="margin-top: 80px;" ref="container">
        <!--发票基本信息卡片-->
        <div class="cardBox">
            <div class="cardTitle flex flex-align">
                <img src="../../../assets/image/icon/order1.svg" alt="">
                <span>{{$t("invoiceDetails.invoiceBaseInfo")}}</span>
            </div>
            <div class="cardBody">
                <div class="flex flex-space-around margin-bottom">
                    <!--发票号-->
                    <div class="inputName" style="margin-top: 10px">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.invoiceNo")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.invoiceNo" readonly
                                  @input="formatUpper('invoiceDoc','invoiceNo',invoiceDoc.invoiceNo)"/>
                    </div>
                    <!--银行账号-->
                    <div class="inputName" style="margin-top: 10px">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("invoiceDetails.accountNo")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.accountNo" readonly
                                  @input="formatUpper('invoiceDoc','accountNo',invoiceDoc.accountNo)"/>
                    </div>
                    <!--开户银行-->
                    <div class="inputName" style="margin-top: 10px">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.bankName")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.bankName" readonly
                                  @input="formatUpper('invoiceDoc','bankName',invoiceDoc.bankName)"/>
                    </div>
                    <!--结算公司-->
                    <div class="inputName" style="margin-top: 10px">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.invSettleOffice")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.invSettleOffice" readonly
                                  @input="formatUpper('invoiceDoc','invSettleOffice',invoiceDoc.invSettleOffice)"/>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--付款单位-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("invoiceDetails.invoiceHeader")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.payer" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','payer',invoiceDoc.payer)"/>
                    </div>
                    <!--船名/航次-->
                    <div class="inputName">
                        <el-col :span="7" style="width: 30%">
                                    <span class="inputName-title">{{$t("invoiceDetails.vesselCodeVoyage")}}</span>
                            <el-input v-model="invoiceDoc.vesselCode" :placeholder="$t('common.pleaseSelect')" :readonly="!getEditable"
                                      @input="formatUpper('invoiceDoc','vesselCode',invoiceDoc.vesselCode)"/>
                        </el-col>
                        <el-col :span="7" style="width: 30%">
                            <el-input v-model="invoiceDoc.voyageNo" :placeholder="$t('common.pleaseSelect')" :readonly="!getEditable"
                                      @input="formatUpper('invoiceDoc','voyageNo',invoiceDoc.voyageNo)"/>
                        </el-col>
                        <el-col :span="5" style="width: 25%">
                            <el-input v-model="invoiceDoc.voyageLeg" :placeholder="$t('common.pleaseSelect')" :readonly="!getEditable"
                                      @input="formatUpper('invoiceDoc','voyageLeg',invoiceDoc.voyageLeg)"/>
                        </el-col>
                        <el-col :span="3" style="width: 10%">
                            <!--VVL弹框-->
                            <el-popover ref="tablePopoverVVLInfo" placement="bottom" width="700" trigger="click" :disabled="!getEditable"
                                        @hide="boatListShow=false">
                                <div>
                                    <div class="flex flex-space-between">
                                        <!--船名查询条件-->
                                        <div class="inputName-left boatBox">
                                            <div class="inputName-title-left">
                                                        <span>
                                                            {{$t('booking.popover.vessel')}}
                                                        </span>
                                            </div>
                                            <el-input v-model="vvlSearch.vesselCode" :placeholder="$t('common.pleaseEnter')"
                                                      clearable
                                                      @focus="showVesselList">
                                                <img src="../../../assets/image/icon/classification.svg"
                                                     slot="suffix"
                                                     @click="showVesselList">
                                            </el-input>
                                            <!--船名列表-->
                                            <div class="boatBox-list-box" v-show="boatListShow">
                                                <div class="boatBox-top flex">
                                                    <div class="left">
                                                        {{$t('booking.popover.vesselCode')}}
                                                    </div>
                                                    <div class="right">
                                                        {{$t('booking.popover.vesselNameCn')}}
                                                    </div>
                                                </div>
                                                <ul>
                                                    <li v-for="(i,j) in boatList" class="flex"
                                                        :key="j"
                                                        @click="checkBoatData(i)">
                                                        <div class="left">{{i.vesselCode}}</div>
                                                        <div class="right">{{i.vesselNameCn}}</div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <!--船中文名查询条件-->
                                        <div class="inputName-left">
                                            <div class="inputName-title-left">
                                                        <span>{{$t('booking.popover.vesselNameCn')}}</span>
                                            </div>
                                            <el-input v-model="vvlSearch.vesselName" :placeholder="$t('common.pleaseEnter')"
                                                      clearable/>
                                        </div>
                                        <!--VVL查询按钮-->
                                        <el-button class="popoverInner" size="small" icon="el-icon-search"
                                                   @click="vvlPopoverSearch">
                                            {{findButton}}
                                        </el-button>
                                    </div>
                                    <div class="flex flex-space-between">
                                        <!--航次查询条件-->
                                        <div class="inputName-left">
                                            <div class="inputName-title-left">
                                                <span>{{$t('booking.popover.voyageNo')}}</span>
                                            </div>
                                            <el-input v-model="vvlSearch.voyageNo" :placeholder="$t('common.pleaseEnter')"
                                                      clearable/>
                                        </div>
                                        <!--航段查询条件-->
                                        <div class="inputName-left">
                                            <div class="inputName-title-left">
                                                <span>{{$t('booking.popover.voyageLeg')}}</span>
                                                <span style="visibility:hidden"></span>
                                            </div>
                                            <el-input v-model="vvlSearch.voyageLeg" :placeholder="$t('common.pleaseEnter')"
                                                      clearable/>
                                        </div>
                                        <!--VVL关闭按钮-->
                                        <el-button size="small" class="popoverInner"
                                                   icon="el-icon-warning-outline"
                                                   @click="vvlPopoverClose">
                                            {{closeButton}}
                                        </el-button>
                                    </div>
                                    <!--船名数据查询表格-->
                                    <el-table :data="tablePopoverVVLInfo" style="width:100%;margin-top:5px"
                                              max-height="300" highlight-current-row
                                              :header-cell-style="{background:'#E9E9E9',height:'36px',padding:0}"
                                              :row-style="{height:'35px'}" :cell-style="{padding:'0px'}"
                                              :empty-text="$t('common.noData')"
                                              @row-dblclick="vvlPopTableRowDbClick"
                                              @row-click="vvlPopTableRowClick">
                                        <!--序号-->
                                        <el-table-column min-width="60" type="index"
                                                         :label="$t('booking.popover.no')"
                                                         align="center"></el-table-column>
                                        <!--船舶代码-->
                                        <el-table-column min-width="110" prop="vesselCode"
                                                         :label="$t('booking.popover.vesselCode')"
                                                         align="center"></el-table-column>
                                        <!--船名-->
                                        <el-table-column min-width="190" prop="vesselName"
                                                         :label="$t('booking.popover.vessel')"
                                                         align="center"></el-table-column>
                                        <!--船中文名-->
                                        <el-table-column min-width="140" prop="vesselNameCn"
                                                         :label="$t('booking.popover.vesselNameCN')"
                                                         align="center"></el-table-column>
                                        <!--航次-->
                                        <el-table-column min-width="100" prop="voyageNo"
                                                         :label="$t('booking.popover.voyageNo')"
                                                         align="center"></el-table-column>
                                        <!--航段-->
                                        <el-table-column min-width="110" prop="voyageLeg"
                                                         :label="$t('booking.popover.voyageLeg')"
                                                         align="center"></el-table-column>
                                    </el-table>
                                    <div class="flex flex-space-between">
                                        <div class="topMargin flex1">
                                            {{getTotalDisplay}}
                                        </div>
                                        <!--VVL确认按钮-->
                                        <el-button class="topMargin" type="primary"
                                                   @click="vvlPopoverConfirm">
                                            {{confirmButton}}
                                        </el-button>
                                        <!--VVL pagination分页条-->
                                        <div class="pagination flex1">
                                            <el-pagination small layout="sizes,pager"
                                                           :page-size="vvlSearch.popPageSize" :page-sizes="[5, 10]"
                                                           :total="vvlSearch.popTotal"
                                                           :pager-count="vvlSearch.popPageCount"
                                                           :current-page="vvlSearch.popPageNum"
                                                           @size-change="popVVLHandleSizeChange"
                                                           @current-change="popVVLHandleCurrentChange"
                                                           max-height="600"></el-pagination>
                                        </div>
                                    </div>
                                </div>
                                <img slot="reference" style="cursor:pointer" class="voyageIcon"
                                     src="../../../assets/image/voyage.png"/>
                            </el-popover>
                        </el-col>
                    </div>
                    <!--提(运)单号-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.businessNo")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.blNo" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','blNo',invoiceDoc.blNo)"/>
                    </div>
                    <!--开票日期-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("invoiceDetails.issuedDate")}}</span>
                        </div>
                        <el-date-picker v-model="invoiceDoc.issuedDate" type="date" class="dateInput1" disabled/>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--开航日-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.etd")}}</span>
                        </div>
                        <el-date-picker v-model="invoiceDoc.etd" type="date" class="dateInput1" :readonly="!getEditable"/>
                    </div>
                    <!--到港日-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.eta")}}</span>
                        </div>
                        <el-date-picker type="date" class="dateInput1" :readonly="!getEditable"
                                        placeholder=""/>
                    </div>
                    <!--电子发票-->
                    <div class="inputName" style="text-align: right">
                        <el-checkbox v-model="invoiceDoc.electronicInvoiceFlag" style="margin-right: 10px; margin-top: 10px" :disabled="!getEditable"
                                     @change="updateInoviceTypeOpyions">{{$t("invoiceDetails.electronicInvoiceFlag")}}</el-checkbox>
                    </div>
                    <!--发票类型-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("invoiceDetails.invoiceType")}}</span>
                        </div>
                        <el-select v-model="invoiceDoc.invoiceType" :placeholder="$t('common.pleaseSelect')" aria-readonly style="height: 40px" :disabled="!getEditable">
                            <el-option v-for="item in invoiceTypeOptions" :disabled="item.disabled"
                                       :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue">
                                <span style="float: left">{{item.displayValueCn}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--起运港-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.portLoadName")}}</span>
                        </div>
                        <el-select v-model="invoiceDoc.portLoadName"
                                   placeholder=""
                                   clearable filterable default-first-option disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode" :label="item.portCode" :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--卸货港-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.portDiscName")}}</span>
                        </div>
                        <el-select v-model="invoiceDoc.portDiscName"
                                   placeholder=""
                                   clearable filterable default-first-option disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode" :label="item.portCode" :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--目的港-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.portDestName")}}</span>
                        </div>
                        <el-select v-model="invoiceDoc.portDestName"
                                   placeholder=""
                                   clearable filterable default-first-option disabled
                                   @focus="portFocus">
                            <el-option v-for="item in portOptions"
                                       :key="item.portCode" :label="item.portCode" :value="item.portCode">
                                <span style="float: left">{{item.portCode}}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.portNameCn}}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <!--税务版本号-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.taxVersionNum")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.taxVersionNum" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','taxVersionNum',invoiceDoc.taxVersionNum)"/>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--原币-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.quoteCurrency")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.quoteCurrency" readonly
                                  @input="formatUpper('invoiceDoc','quoteCurrency',invoiceDoc.quoteCurrency)"/>
                    </div>
                    <!--原币金额-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.quoteAmount")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.quoteAmount" readonly/>
                    </div>
                    <!--开户行-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.payerBank")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.payerBank" readonly
                                  @input="formatUpper('invoiceDoc','payerBank',invoiceDoc.payerBank)"/>
                    </div>
                    <!--账号-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.payerAccountNo")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.payerAccountNo" readonly
                                  @input="formatUpper('invoiceDoc','payerAccountNo',invoiceDoc.invoiceNo)"/>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--联系人-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.payerContacts")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.payerContacts" readonly
                                  @input="formatUpper('invoiceDoc','payerContacts',invoiceDoc.payerContacts)"/>
                    </div>
                    <!--电话-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.payerTel")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.payerTel" readonly
                                  @input="formatUpper('invoiceDoc','payerTel',invoiceDoc.payerTel)"/>
                    </div>
                    <!--客户Email-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.customerEmail")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.customerEmail" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','customerEmail',invoiceDoc.customerEmail)"/>
                    </div>
                    <!--开票地址-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span class="redColor">{{$t("invoiceDetails.payerBillingAddress")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.payerBillingAddress" readonly
                                  @input="formatUpper('invoiceDoc','payerBillingAddress',invoiceDoc.payerBillingAddress)"/>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--工商登记号-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.businessRegisterNo")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.businessRegisterNo" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','businessRegisterNo',invoiceDoc.businessRegisterNo)"/>
                    </div>
                    <!--税务登记号-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.taxRegisterNo")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.taxRegisterNo" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','taxRegisterNo',invoiceDoc.taxRegisterNo)"/>
                    </div>
                    <div class="inputName">
                    </div>
                    <div class="inputName">
                    </div>
<!--                    &lt;!&ndash;发票状态&ndash;&gt;-->
<!--                    <div class="inputName">-->
<!--                        <div class="inputName-title">-->
<!--                            <span>发票状态</span>-->
<!--                        </div>-->
<!--                        <el-select v-model="invoiceDoc.isCancelled" :placeholder="$t('common.pleaseSelect')" style="height: 40px" disabled>-->
<!--                            <el-option v-for="item in isCancelledOptions"-->
<!--                                       :key="item.codeValue" :label="getDisplayValue(item)" :value="item.codeValue">-->
<!--                                <span style="float: left">{{item.displayValueCn}}</span>-->
<!--                                <span style="float: right; color: #8492a6; font-size: 13px">{{item.displayValue}}</span>-->
<!--                            </el-option>-->
<!--                        </el-select>-->
<!--                    </div>-->
                </div>
            </div>
        </div>

        <div class="cardBox">
            <div class="cardBody" style="margin-bottom: 10px">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="$t('invoiceDetails.chargingContent')" name="first">
                        <div class="flex flex-space-around" style="margin-top: 10px;margin-bottom: 15px">
                            <el-col style="width: 30%">
                                <el-col style="width: 50%; ">
                                    <!--提(运)单号-->
                                    <div class="inputName">
                                        <span class="inputName-title redColor">{{$t("invoiceDetails.businessNo")}}</span>
                                        <el-input v-model="invoiceDoc.businessNo" :placeholder="$t('common.pleaseEnter')" type="textarea"
                                                  :rows="5" show-word-limit readonly
                                                  clearable
                                                  @input="formatUpper('invoiceDoc','businessNo',invoiceDoc.businessNo)"/>
                                    </div>
                                </el-col>
                                <el-col style="width: 50%; ">
                                    <!--费用明细-->
                                    <div class="inputName">
                                        <span class="inputName-title redColor">{{$t("invoiceDetails.expenseDetails")}}</span>
                                        <el-input v-model="invoiceDoc.freightName" :placeholder="$t('common.pleaseEnter')" type="textarea"
                                                  :rows="5" show-word-limit readonly
                                                  clearable
                                                  @input="formatUpper('invoiceDoc','freightName',invoiceDoc.freightName)"/>
                                    </div>
                                </el-col>
                            </el-col>
                            <el-col style="width: 45%">
                                <el-col style="width: 18%; ">
                                    <!--数量-->
                                    <div class="inputName">
                                        <span class="inputName-title redColor">{{$t("invoiceDetails.quantity")}}</span>
                                        <el-input v-model="invoiceDoc.quantity" :placeholder="$t('common.pleaseEnter')" type="textarea"
                                                  :rows="5" show-word-limit readonly
                                                  clearable
                                                  @input="formatUpper('invoiceDoc','quantity',invoiceDoc.quantity)"/>
                                    </div>
                                </el-col>
                                <el-col style="width: 32%">
                                    <!--单价-->
                                    <div class="inputName">
                                        <span class="inputName-title redColor">{{$t("invoiceDetails.unitPrice")}}</span>
                                        <el-input v-model="invoiceDoc.unitPrice" :placeholder="$t('common.pleaseEnter')" type="textarea"
                                                  :rows="5" show-word-limit readonly
                                                  clearable
                                                  @input="formatUpper('invoiceDoc','unitPrice',invoiceDoc.unitPrice)"/>
                                    </div>
                                </el-col>
                                <el-col style="width: 18%">
                                    <!--币别-->
                                    <div class="inputName">
                                        <span class="inputName-title redColor">{{$t("invoiceDetails.currencyType")}}</span>
                                        <el-input v-model="invoiceDoc.currency" :placeholder="$t('common.pleaseEnter')" type="textarea"
                                                  :rows="5" show-word-limit readonly
                                                  clearable
                                                  @input="formatUpper('invoiceDoc','currency',invoiceDoc.currency)"/>
                                    </div>
                                </el-col>
                                <el-col style="width: 32%">
                                    <!--开票金额-->
                                    <div class="inputName">
                                        <span class="inputName-title redColor">
                                            {{$t("invoiceDetails.settleAmount")}}
                                        </span>
                                        <el-input v-model="invoiceDoc.settleAmount" :placeholder="$t('common.pleaseEnter')" type="textarea"
                                                  :rows="5" show-word-limit readonly
                                                  clearable
                                                  @input="formatUpper('invoiceDoc','settleAmount',invoiceDoc.settleAmount)"/>
                                    </div>
                                </el-col>
                            </el-col>
                            <!--备注-->
                            <div class="inputName">
                                <span class="inputName-title">
                                    {{$t("invoiceDetails.remark")}}
                                </span>
                                <el-input v-model="invoiceDoc.remark" :placeholder="$t('common.pleaseEnter')"
                                          type="textarea"
                                          :rows="5" show-word-limit readonly
                                          clearable
                                          @input="formatUpper('invoiceDoc','remark',invoiceDoc.remark)"/>
                            </div>
                        </div>
                        <div class="flex flex-space-around margin-bottom">
                            <el-col style="width: 36%">
                                <!--合计金额(大写)-->
                                <div class="inputName">
                                    <el-col :span="7" style="width: 25%">
                                        <div class="inputName-title">
                                            <span class="redColor">{{$t("invoiceDetails.totalAmountB")}}</span>
                                        </div>
                                        <!--币种-->
                                        <el-select ref="currencySelect" v-model="invoiceDoc.currency" clearable  disabled
                                                   :placeholder="$t('common.pleaseSelect')"
                                                   @focus="currencyCodeFocus"
                                                   @change="updateTotalAmount">
                                            <el-option
                                                    v-for="item in currencyOptions"
                                                    :key="item.currencyCode"
                                                    :label="item.currencyCode"
                                                    :value="item.currencyCode">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="7" style="width: 75%">
                                        <el-input v-model="getTotalSay" :placeholder="$t('common.pleaseEnter')" disabled/>
                                    </el-col>
                                </div>
                            </el-col>
                            <el-col style="width: 25%">
                                <!--合计金额(小写)-->
                                <div class="inputName">
                                    <div class="inputName-title">
                                        <span>{{$t("invoiceDetails.totalAmountS")}}</span>
                                    </div>
                                    <el-input v-model="invoiceDoc.totalAmount" readonly/>
                                </div>
                            </el-col>
                            <el-col style="width: 12%">
                                <!--月份-->
                                <div class="inputName">
                                    <div class="inputName-title">
                                        <span>{{$t("invoiceDetails.rateMonth")}}</span>
                                    </div>
                                    <el-select ref="rateMonthSelect" v-model="invoiceDoc.rateMonth" :placeholder="$t('common.pleaseSelect')" disabled
                                               filterable default-first-option @change="updateTotalAmount">
                                        <el-option v-for="item in monthOptions"
                                                   :key="item.value" :label="item.label" :value="item.value">
                                            <span style="float: left">{{item.value}}</span>
                                            <span style="float: right; color: #8492a6; font-size: 13px">{{item.labelEn}}</span>
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <!--月度汇率-->
                            <div class="inputName">
                                <div class="inputName-title">
                                    <span>{{$t("invoiceDetails.exchangeRate")}}</span>
                                </div>
                                <el-input v-model="invoiceDoc.exchangeRate" readonly/>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('invoiceDetails.invoiceBLInfo')" name="second">
                        <vxe-table :data="tableInvoiceBLInfo"
                                ref="tableInvoiceBLInfo" class="vxeTable"
                                height="204" size="mini"
                                :row-config="{isCurrent: true, isHover: true}"
                                :column-config="{resizable: true}"
                                show-header-overflow show-overflow>
                            <!--序号-->
                            <vxe-column type="seq" width="50" title="estimateDetails.estContainerPic.index" show-overflow></vxe-column>
                            <!--提单号-->
                            <vxe-column field="businessNo" title="invoiceDetails.blNo" width="180" show-overflow sortable></vxe-column>
                            <!--对账单号-->
                            <vxe-column field="ledgerCompNo" title="invoiceDetails.ledgerCompNo" width="150" show-overflow></vxe-column>
                            <!--船舶代码-->
                            <vxe-column field="vesselCode" title="invoiceDetails.vesselCode" width="120" show-overflow sortable></vxe-column>
                            <!--航次-->
                            <vxe-column field="voyageNo" title="invoiceDetails.voyageNo" width="120" show-overflow sortable></vxe-column>
                            <!--航段-->
                            <vxe-column field="voyageLeg" title="invoiceDetails.voyageLeg" width="120" show-overflow sortable></vxe-column>
                            <!--原币-->
                            <vxe-column field="primeCurrencyCode" title="invoiceDetails.primeCurrencyCode" width="170" show-overflow sortable></vxe-column>
                            <!--原币金额-->
                            <vxe-column field="primeCurrencyValue" title="invoiceDetails.primeCurrencyValue" width="180" show-overflow sortable>
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.primeCurrencyValue, 2)}}</span>
                                </template>
                            </vxe-column>
                            <!--客户名称-->
                            <vxe-column field="ledgerPartnerName" title="invoiceDetails.ledgerPartnerName" width="180" show-overflow sortable></vxe-column>
                            <!--结算公司-->
                            <vxe-column field="officeId" title="invoiceDetails.officeId" width="100" show-overflow sortable></vxe-column>
                            <!--开票状态-->
                            <vxe-column field="invoiceStatus" title="invoiceDetails.invoiceStatus" width="130" show-overflow sortable>
                                <template slot-scope="scope">
                                    <span>{{getInvoiceStatusDisplayValue(scope.row.invoiceStatus)}}</span>
                                </template>
                            </vxe-column>
                            <!--核销状态-->
                            <vxe-column field="allocatedStatus" title="invoiceDetails.allocatedStatus" width="140" show-overflow sortable>
                                <template slot-scope="scope">
                                    <span>{{getAllocatedStatusDisplayValue(scope.row.allocatedStatus)}}</span>
                                </template>
                            </vxe-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('invoiceDetails.expenseDetails')" name="third">
                        <vxe-table :data="tableInvoiceFreightInfo"
                                   ref="tableInvoiceFreightInfo" class="vxeTable"
                                   height="204" size="mini"
                                   :row-config="{isCurrent: true, isHover: true}"
                                   :column-config="{resizable: true}"
                                   show-header-overflow show-overflow>
                            <!--序号-->
                            <vxe-column type="seq" width="50" title="estimateDetails.estContainerPic.index"></vxe-column>
                            <!--费用代码-->
                            <vxe-column field="frtId" title="invoiceDetails.expenseCode" width="120" sortable></vxe-column>
                            <!--费用名称-->
                            <vxe-column field="frtName" title="invoiceDetails.expenseName" width="120"></vxe-column>
                            <!--原币-->
                            <vxe-column field="primeCurrencyCode" title="invoiceDetails.primeCurrencyCode" width="150" sortable></vxe-column>
                            <!--本次开票金额-->
                            <vxe-column field="invoiceAmount" title="invoiceDetails.invoiceAmount" width="150" sortable>
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.invoiceAmount, 2)}}</span>
                                </template>
                            </vxe-column>
                            <!--汇率-->
                            <vxe-column field="rateToInvoice" title="invoiceDetails.rateToInvoice" width="150" sortable></vxe-column>
                            <!--可开票原币金额-->
                            <vxe-column field="invoicablePrimeCurrencyValue" title="invoiceDetails.invoicablePrimeCurrencyValue" width="150" sortable>
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.invoicablePrimeCurrencyValue, 2)}}</span>
                                </template>
                            </vxe-column>
                            <!--已开票原币金额-->
                            <vxe-column field="invoicedPrimeCurrencyValue" title="invoiceDetails.invoicedPrimeCurrencyValue" width="150" sortable>
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.invoicedPrimeCurrencyValue, 2)}}</span>
                                </template>
                            </vxe-column>
                            <!--原币金额-->
                            <vxe-column field="primeCurrencyValue" title="invoiceDetails.primeCurrencyValue" width="180" sortable>
                                <template slot-scope="scope">
                                    <span>{{formatNumber(scope.row.primeCurrencyValue, 2)}}</span>
                                </template>
                            </vxe-column>
                            <!--客户名称-->
                            <vxe-column field="ledgerPartnerName" title="invoiceDetails.ledgerPartnerName" width="180" sortable></vxe-column>
                            <!--船舶代码-->
                            <vxe-column field="vesselCode" title="invoiceDetails.vesselCode" width="120" sortable></vxe-column>
                            <!--航次-->
                            <vxe-column field="voyageNo" title="invoiceDetails.voyageNo" width="100" sortable></vxe-column>
                            <!--航段-->
                            <vxe-column field="voyageLeg" title="invoiceDetails.voyageLeg" width="110" sortable></vxe-column>
                            <!--提单号-->
                            <vxe-column field="blNo" title="invoiceDetails.blNo" width="180" sortable></vxe-column>
                            <!--对账单号-->
                            <vxe-column field="ledgerCompNo" title="invoiceDetails.ledgerCompNo" width="180" sortable></vxe-column>
                        </vxe-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>

        <div class="cardBox">
            <div class="cardBody">
                <div class="flex flex-space-around margin-bottom">
                    <!--发送方代码-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.businessSeal")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.businessSeal" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','businessSeal',invoiceDoc.businessSeal)"/>
                    </div>
                    <!--港口/堆场-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.receiver")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.receiver" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','receiver',invoiceDoc.receiver)"/>
                    </div>
                    <!--代理-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.applicatEmail")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.applicatEmail" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','applicatEmail',invoiceDoc.applicatEmail)"/>
                    </div>
                </div>
                <div class="flex flex-space-around margin-bottom">
                    <!--付款单位-->
                    <div class="inputName">
                        <div class="inputName-title">
                            <span>{{$t("invoiceDetails.finDeliveryAddress")}}</span>
                        </div>
                        <el-input v-model="invoiceDoc.finDeliveryAddress" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                  @input="formatUpper('invoiceDoc','finDeliveryAddress',invoiceDoc.finDeliveryAddress)"/>
                    </div>
                    <!--船名/航次-->
                    <div class="inputName">
                        <el-col :span="12" style="width: 49%">
                            <div class="inputName-title">
                                <span>{{$t("invoiceDetails.checkedName")}}</span>
                            </div>
                            <el-input v-model="invoiceDoc.checkedName" :placeholder="$t('common.pleaseEnter')" :readonly="!getEditable"
                                      @input="formatUpper('invoiceDoc','checkedName',invoiceDoc.checkedName)"/>
                        </el-col>
                        <el-col :span="12" style="width: 49%; margin-left: 5px">
                            <el-input v-model="invoiceDoc.issuedName" :placeholder="$t('common.pleaseEnter')" readonly
                                      @input="formatUpper('invoiceDoc','issuedName',invoiceDoc.issuedName)"/>
                        </el-col>
                    </div>
                    <div class="inputName">
                    </div>
                </div>
            </div>
        </div>

        <!--底部按钮组-->
        <div class="footer-group">
            <!--保存按钮-->
            <el-button class="save-green-button" type="success" :disabled="!getSaveBtnStatus"
                       @click="returnSave">
                {{$t('common.saveBtn')}}
            </el-button>
            <!--删除按钮-->
            <el-button type="primary" class="return-button" :disabled="!getDeleteBtnStatus"
                       @click="returnDelete">
                {{$t('common.deleteButton')}}
            </el-button>
            <!--提交按钮-->
            <el-button class="save-blue-button"
                       @click="returnSubmit">
                {{$t("invoiceDetails.submit")}}
            </el-button>
            <!--申请退回按钮-->
            <el-button class="return-button" type="warning"
                       @click="returnApply">
                {{$t("invoiceDetails.returnApply")}}
            </el-button>
            <!--返回按钮-->
            <el-button class="return-button" type="info"
                       @click="returnPage">
                {{returnButton}}
            </el-button>
        </div>

        <!--页面底部组件-->
        <div class="footerSpan">
            <span></span>
        </div>
    </div>
</template>
<script>
    import {convertCurrency} from "../../../utils/formatInput";
    import Watermark from "../../../utils/waterMark.js";

    export default {
        name: 'invoiceDetails',
        computed: {
            /************************************ 页面按钮国际化信息 ***********************************/
            /**
             * 返回按钮
             */
            returnButton() { return this.$t("common.returnButton") },
            /**
             * 搜索按钮
             */
            findButton() { return this.$t("common.findButton") },
            /**
             * 关闭按钮
             */
            closeButton() { return this.$t("common.closeButton") },
            /**
             * 确认按钮
             */
            confirmButton() { return this.$t("common.confirmButton") },
            /**
             * 船名航次弹框数据总条数
             */
            getTotalDisplay() { return this.$t("common.total").replace("?", this.vvlSearch.popTotal) },
            /**
             * 获取合计金额大写
             */
            getTotalSay(){
                return convertCurrency(this.invoiceDoc.totalAmount);
            },
            // 页面编辑状态控制
            getEditable(){
                return this.invoiceDoc != null
                    && this.invoiceDoc.isCancelled === 0        // 未提交
                    && !this.invoiceDoc.isPrinted               //未打印
                    && this.invoiceDoc.allocationStatus === 0;  // 未核销
            },
            // 保存按钮状态控制
            getSaveBtnStatus() {
                return this.getEditable;
            },
            // 删除按钮状态控制
            getDeleteBtnStatus() {
                // 获取当前登录账号
                let curUser = sessionStorage.getItem("ACCOUNT_CODE");
                if (curUser == null || curUser === ""){
                    return false;
                }
                return this.invoiceDoc != null
                    && this.invoiceDoc.isCancelled === 0
                    && curUser === this.invoiceDoc.issuedBy;
            },
        },
        data() {
            return {
                activeName: 'first',
                invoiceTypeOptions: [               // 发票类型下拉值
                    {codeValue: "ZP", displayValueCn: "纸普", displayValue: "PAPER ORDINARY"},
                    {codeValue: "XS", displayValueCn: "形式", displayValue: "PROFORMA"},
                ],          // 发票类型下拉选项
                currencyOptions: [],                // 币种下拉选项
                portOptions: [],                    // 港口下拉选项
                monthOptions: [
                    {value: 1, label: 1, labelEn: "Jan"},
                    {value: 2, label: 2, labelEn: "Feb"},
                    {value: 3, label: 3, labelEn: "Mar"},
                    {value: 4, label: 4, labelEn: "Apr"},
                    {value: 5, label: 5, labelEn: "May"},
                    {value: 6, label: 6, labelEn: "Jun"},
                    {value: 7, label: 7, labelEn: "Jul"},
                    {value: 8, label: 8, labelEn: "Aug"},
                    {value: 9, label: 9, labelEn: "Sep"},
                    {value: 10, label: 10, labelEn: "Oct"},
                    {value: 11, label: 11, labelEn: "Nov"},
                    {value: 12, label: 12, labelEn: "Dec"}
                ],                // 月份下拉选项
                isCancelledOptions: [               // 发票状态下拉值
                    {codeValue: 0, displayValueCn: "未提交", displayValue: "NOT SUBMITTED"},
                    {codeValue: 1, displayValueCn: "已作废", displayValue: "CANCELLED"},
                    {codeValue: 2, displayValueCn: "已红冲", displayValue: "RED RUSHED"},
                    {codeValue: 3, displayValueCn: "已提交", displayValue: "SUBMITTED"},
                    {codeValue: 4, displayValueCn: "已开票", displayValue: "ISSUED"},
                    {codeValue: 5, displayValueCn: "申请作废 ", displayValue: "APPLY CANCELLATION"},
                    {codeValue: 6, displayValueCn: "申请红冲", displayValue: "APPLICATION RED RUSH"},
                    {codeValue: 7, displayValueCn: "已锁定", displayValue: "LOCKED"},
                    {codeValue: 8, displayValueCn: "申请退回", displayValue: "APPLYING GO BACK"},
                ],
                invoiceStatusOptions: [     // 开票状态
                    {codeValue: 1, displayValueCn: "未开票", displayValue: "UNINVOICED", disabled:false},
                    {codeValue: 2, displayValueCn: "部分开票", displayValue: "PARTIAL INVOICED", disabled:false},
                    {codeValue: 3, displayValueCn: "已开票", displayValue: "INVOICED", disabled:false},
                ],
                allocatedStatusOptions: [
                    {codeValue: 0, displayValueCn: "未核销", displayValue: "UN-VERIFICATED", disabled:false},
                    {codeValue: 1, displayValueCn: "部分核销", displayValue: "PART ALLOCATION", disabled:false},
                    {codeValue: 2, displayValueCn: "已核销", displayValue: "VERIFICATED", disabled:false},
                ],

                isSaveClick: false,                 // 控制保存按钮点击频率
                isVVLSearchClick: false,            // 控制船名航次弹框查询按钮点击频率
                boatListShow: false,                //控制船舶查询弹框是否显示

                invoiceDoc: {
                    invoiceNo: "",                  // 发票号
                    accountNo: "",                  // 银行账号
                    bankName: "",                   // 开户银行
                    invSettleOffice: "",            // 结算公司
                    payer: "",                      // 付款单位-发票抬头
                    payerId: "",                    // 付款单位代码
                    vesselCode: "",                 // 船名
                    voyageNo: "",                   //  航次
                    voyageLeg: "",                  // 航段
                    blNo: "",                       // 提(运)单号
                    issuedDate: "",                 // 开票日期
                    etd: "",                        // 开航日
                    eta: "",                        // 到港日
                    portLoadName: "",               // 起运港
                    portDiscName: "",               // 卸货港
                    portDestName: "",               // 目的港
                    electronicInvoiceFlag: "",      // 是否电子发票
                    invoiceType: "",                // 发票类型
                    quoteCurrency: "",              // 原币
                    quoteAmount: "",                // 原币金额
                    entrustFlag: "",                // 是否托收
                    payerBank: "",                  // 开户行
                    payerAccountNo: "",             // 账号
                    payerContacts: "",              // 联系人
                    payerTel: "",                   // 电话
                    customerEmail: "",                 // 客户Email
                    payerBillingAddress: "",        // 开票地址
                    businessRegisterNo: "",         // 工商登记号
                    taxRegisterNo: "",              // 税务登记号
                    taxVersionNum: "",              // 税务版本号
                    businessSeal: "",               // 企业签章
                    receiver: "",                   // 领用人
                    applicatEmail: "",              // 申请人Email
                    finDeliveryAddress: "",         // 财务快递地址
                    checkedName: "",                // 复核人
                    issuedName: "",                 // 制单人
                    // 【收费内容信息】
                    businessNo: "",                 // 提单号
                    freightName: "",                // 费用明细
                    quantity: "",                   // 数量
                    unitPrice: "",                  // 费率
                    currency: "",                   // 币种
                    settleAmount: "",               // 结算金额
                    remark: "",                     // 备注
                    totalSay: "",                   // 合计金额(大写)
                    rateMonth: "",                  // 付款月份
                    exchangeRate: "",               // 月度汇率
                    totalAmount: "",                // 合计金额(小写)
                },
                // 船名/航次弹框查询参数
                vvlSearch: {
                    vesselCode: "",                 // 船舶代码
                    vesselName: "",                 // 船舶中文名
                    voyageNo: "",                   // 航次
                    voyageLeg: "",                  // 航段
                    popPageCount: 5,                // 总页数
                    popPageNum: 1,                  // 当前页码
                    popPageSize: 5,                 // 单页显示数据条数
                    popTotal: 0,                    // 数据总条数
                },

                // 【发票提单号数据】
                tableInvoiceBLInfo: [
                    {
                        businessNo: "",             // 提单号
                        ledgerCompNo: "",           // 对账单号
                        vesselCode: "",             // 船名
                        voyageNo: "",               //  航次
                        voyageLeg: "",              // 航段
                        primeCurrencyCode: "",      // 原币币别
                        primeCurrencyValue: "",     // 原币金额
                        ledgerPartnerName: "",      // 客户名称
                        officeId: "",               // 结算部门
                        invoiceStatus: "",          // 开票状态
                        allocatedStatus: "",        // 核销状态
                    }
                ],
                // 【发票费用明细】
                tableInvoiceFreightInfo: [
                    {
                        frtId: "",                  // 费用代码
                        frtName: "",                // 费用名称
                        primeCurrencyCode: "",      // 原币
                        invoiceAmount: "",          // 本次开票金额
                        rateToInvoice: "",          // 汇率
                        invoicablePrimeCurrencyValue: "",// 可开票原币金额
                        InvoicedPrimeCurrencyValue: "",// 已开票原币金额
                        primeCurrencyValue: "",     // 总金额
                        ledgerPartnerName: "",      // 客户名称
                        vesselCode: "",             // 船舶代码
                        voyageNo: "",               //  航次
                        voyageLeg: "",              // 航段
                        BusinessNo: "",             // 提单号
                        ledgerCompNo: "",           // 对账单号
                    }
                ],
                // 船名航次弹框 【船名航次数据】
                boatList: [],                       // 船舶数据
                tablePopoverVVLInfo: [],
                tablePopoverVVLSelection: [],       // 船名航次弹框中表格当前点击选中的数据
                // 【开票对账单数据】
                statementOfAccountList: []
            }
        },
        methods: {
            /************************************ 工具栏按钮点击事件 *************************************/
            /**
             * 发票保存
             */
            returnSave() {
                if (this.isSaveClick) {
                    return;
                }
                this.isSaveClick = true;

                // 获取页面发票信息
                const condition = this.returnCondition();
                if(condition.invoiceDocId == null || condition.invoiceDocId === ""){
                    // 发票新增保存
                    let statementOfAccountIds = [];// 发票新增保存时，需携带开票对账单信息到服务端
                    if(this.statementOfAccountList.length > 0){
                        this.statementOfAccountList.forEach((sa)=>{
                            statementOfAccountIds.push(sa.statementOfAccountId)
                        })
                    }

                    // 声明一个loading对象
                    this.loadingtuo1 = this.$loading({
                        lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                        text: this.$t("invoiceDetails.carriedForward"),             // 加载动画的文字
                        spinner: 'el-icon-loading',                     // 引入的loading图标
                        background: "rgb(0,0,0,0.1)",
                    });
                    let that = this.loadingtuo1;

                    // 对账单结转财务
                    this.axios({
                        method: 'post',
                        url: '/api/statementOfAccount/statementOfAccountTransferToFinance',
                        data: {
                            statementOfAccountIds: JSON.stringify(statementOfAccountIds)
                        },
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            that.close();

                            // 对账单结转财务成功，保存发票内容
                            this.loadingtuo2 = this.$loading({
                                lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                                text: this.$t("invoiceDetails.invoiceSave"),           // 加载动画的文字
                                spinner: 'el-icon-loading',                     // 引入的loading图标
                                background: "rgb(0,0,0,0.1)",
                            });
                            this.axios({
                                method: 'post',
                                url: '/api/invoiceDoc/invoiceDocSave',
                                data: {
                                    invoiceDocInfo: condition,
                                    statementOfAccountIds: JSON.stringify(statementOfAccountIds)
                                },
                                headers: {
                                    'Accept-language': localStorage.getItem("locale")
                                }
                            }).then(response => {
                                this.responseCode = response.data.backMessage;
                                if (response.data.backCode === "200") {
                                    let invoiceDocList = response.data.object;
                                    this.showMessage(false, this.responseCode, "success");
                                    // 更新页面发票内容
                                    if(invoiceDocList != null && invoiceDocList.length > 0){
                                        this.setFieldValue(invoiceDocList[0]);
                                    }
                                } else {
                                    this.showMessage(false, this.responseCode, "error");
                                    // 对账单自动取消结转财务
                                    this.cancelToFinanceAuto(JSON.stringify(statementOfAccountIds));
                                }
                                this.isSaveClick = false;
                                this.loadingtuo2.close();
                            }).catch(error => {
                                this.isSaveClick = false;
                                this.loadingtuo2.close();
                                if (error.data) {
                                    this.responseCode = error.data.backMessage;
                                    this.showMessage(false, this.responseCode, "error");
                                } else {
                                    this.showMessage(false, error, "error");
                                }
                            });
                        } else {
                            that.close();
                            this.showMessage(false, this.responseCode, "error");
                        }
                        this.isSaveClick = false;
                    }).catch(error => {
                        this.isSaveClick = false;
                        that.close();
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                } else {
                    // 发票编辑保存
                    this.loadingtuo2 = this.$loading({
                        lock: true, // 设置加载时是否锁屏,锁屏状态加载区域无法操作
                        text: this.$t("invoiceDetails.invoiceSave"),             // 加载动画的文字
                        spinner: 'el-icon-loading',                     // 引入的loading图标
                        background: "rgb(0,0,0,0.1)",
                    });
                    this.axios({
                        method: 'post',
                        url: '/api/invoiceDoc/invoiceDocSave',
                        data: {
                            invoiceDocInfo: condition
                        },
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            let invoiceDocList = response.data.object;
                            this.showMessage(false, this.responseCode, "success");
                            // 更新页面发票内容
                            if(invoiceDocList != null && invoiceDocList.length > 0){
                                this.setFieldValue(invoiceDocList[0]);
                            }
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                        this.isSaveClick = false;
                        this.loadingtuo2.close();
                    }).catch(error => {
                        this.isSaveClick = false;
                        this.loadingtuo2.close();
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                }
            },
            cancelToFinanceAuto(statementOfAccountIds){
                this.axios({
                    method: 'post',
                    url: '/api/statementOfAccount/batchCancelToFinance',
                    data: {
                        statementOfAccountIds: statementOfAccountIds
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        let invoiceDocList = response.data.object;
                        // 更新页面发票内容
                        if(invoiceDocList != null && invoiceDocList.length > 0){
                            this.setFieldValue(invoiceDocList[0]);
                        }
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                        // 对账单自动取消结转财务
                        this.cancelToFinanceAuto(JSON.stringify(statementOfAccountIds));
                    }
                    this.isSaveClick = false;
                    this.loadingtuo2.close();
                }).catch(error => {
                    this.isSaveClick = false;
                    this.loadingtuo2.close();
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 获取当前页面发票基本数据（公共方法）
             */
            returnCondition() {
                // 【发票基本信息】
                let invoiceDoc = this.invoiceDoc;
                // 是否电子发票标志
                if(this.invoiceDoc.electronicInvoiceFlag){
                    invoiceDoc.electronicInvoiceFlag = 1;
                } else{
                    invoiceDoc.electronicInvoiceFlag = 0;
                }

                invoiceDoc.invoiceDocDetails = [];
                invoiceDoc.invoiceDocDetailVos = [];

                // 【发票明细信息】
                this.tableInvoiceFreightInfo.forEach((feright)=>{
                    invoiceDoc.invoiceDocDetailVos.push(feright);
                });
                return invoiceDoc;
            },
            /**
             * 发票删除
             */
            returnDelete() {
                // 校验发票是否为未提交状态
                if (this.invoiceDoc.isCancelled != null && this.invoiceDoc.isCancelled != 0) {
                    this.$alert(this.$t("message.invoiceDeleteConfirm"), this.$t("common.deleteFail"), {
                        confirmButtonText: this.$t("common.okButton")
                    });
                    return;
                }
                this.$confirm(this.$t("message.invoiceDeleteConfirmTwo"), this.$t("common.pleaseConfirm") , {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("common.deleteButton"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    var invoiceDocIds=[];
                    invoiceDocIds.push(this.invoiceDoc.invoiceDocId);
                    this.axios({
                        method: 'post',
                        url: '/api/invoiceDoc/invoiceDocDelete',
                        data: {
                            invoiceDocIds: JSON.stringify(invoiceDocIds),
                        },
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            this.showMessage(true, this.$t("common.deleteSuccess"), "success");
                            setTimeout(()=>{
                                this.returnPage();
                            },1000);
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                })
            },
            /**
             * 发票提交
             */
            returnSubmit() {
                // 获取当前时间（小时）
                let nowDate = new Date();
                let nowHours = nowDate.getHours();
                let invoiceDocIds = [];
                invoiceDocIds.push(this.invoiceDoc.invoiceDocId);

                this.$confirm(this.$t("message.invoiceSubmitConfirm"), this.$t("common.pleaseConfirm") , {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("invoiceDetails.submit"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    // 校验当前时间超过北京时间16:00，开票日期是否确定更新为明天？
                    if(nowHours > 16){
                        this.$confirm(this.$t("message.invoiceNowHourConfirm"), this.$t("common.pleaseConfirm") , {
                            distinguishCancelAndClose: true,
                            confirmButtonText: this.$t("common.confirmButton"),
                            cancelButtonText: this.$t("common.cancelButton")
                        }).then(() => {
                            // 将开票日期设置为明天

                            let responseCode;
                            // 发送请求到后端
                            this.axios({
                                method: "post",
                                url: "/api/invoiceDoc/invoiceDocSubmit",
                                data: {
                                    invoiceDocIds: JSON.stringify(invoiceDocIds)
                                },
                                headers: {
                                    'Accept-language': localStorage.getItem("locale"),
                                    'Content-type': "application/json;charset=utf-8"
                                }
                            }).then(response => {
                                this.responseCode = response.data.backMessage;
                                if (response.data.backCode === "200") {
                                    this.showMessage(false, this.$t("common.submitSuccess") + this.$t("common.backAuto"), "success");
                                    setTimeout(()=>{
                                        this.returnPage();
                                    },2000);
                                } else {
                                    this.showMessage(false, this.responseCode, "error");
                                }
                            }).catch(error => {
                                if (error.data) {
                                    this.responseCode = error.data.backMessage;
                                    this.showMessage(false, this.responseCode, "error");
                                } else {
                                    this.showMessage(false, error, "error");
                                }
                            });
                        }).catch(action => {
                            //取消
                            if (action === 'cancel') {
                                console.log(action);
                            }
                        })
                    } else{
                        // 直接发送请求到后端
                        this.axios({
                            method: "post",
                            url: "/api/invoiceDoc/invoiceDocSubmit",
                            data: {
                                invoiceDocIds: JSON.stringify(invoiceDocIds)
                            },
                            headers: {
                                'Accept-language': localStorage.getItem("locale"),
                                'Content-type': "application/json;charset=utf-8"
                            }
                        }).then(response => {
                            this.responseCode = response.data.backMessage;
                            if (response.data.backCode === "200") {
                                this.showMessage(false, this.$t("common.submitSuccess") + this.$t("common.backAuto"), "success");
                                setTimeout(()=>{
                                    this.returnPage();
                                },2000);
                            } else {
                                this.showMessage(false, this.responseCode, "error");
                            }
                        }).catch(error => {
                            if (error.data) {
                                this.responseCode = error.data.backMessage;
                                this.showMessage(false, this.responseCode, "error");
                            } else {
                                this.showMessage(false, error, "error");
                            }
                        });
                    }
                }).catch(action => {
                    //取消
                    if (action === 'cancel') {
                        console.log(action);
                    }
                })
            },
            /**
             * 发票申请退回
             */
            returnApply() {
                let invoiceDocIds = [];
                invoiceDocIds.push(this.invoiceDoc.invoiceDocId);

                this.$confirm(this.$t("message.invoiceReturn"), this.$t("common.pleaseConfirm") , {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("invoiceDetails.returnApply"),
                    cancelButtonText: this.$t("common.cancelButton")
                }).then(() => {
                    // 发送请求到后端
                    this.axios({
                        method: "post",
                        url: "/api/invoiceDoc/invoiceDocBackApply",
                        data: {
                            invoiceDocIds: JSON.stringify(invoiceDocIds)
                        },
                        headers: {
                            'Accept-language': localStorage.getItem("locale"),
                            'Content-type': "application/json;charset=utf-8"
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            this.showMessage(false, this.$t("message.returnApply"), "success");
                            this.$router.back(-1);
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                })
            },
            /**
             * 返回按钮点击
             */
            returnPage() {
                // this.$router.back(-1)
                window.opener = null;
                window.open("about:blank", "_top").close()
            },

            /************************************ 船名航次弹出框 ************************************/
            /**
             * 船名下拉选赋值
             */
            showVesselList() {//船名输入框点击
                this.boatListShow = true;
                this.axios({
                    method: 'get',
                    url: '/api/codedict/getVesselList',
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.boatList = response.data.object;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 船名下拉表格数据点击事件
             */
            checkBoatData(boat) {
                this.vvlSearch.vesselCode = boat.vesselCode;
                this.vvlSearch.vesselName = boat.vesselName;
                this.boatListShow = false
            },
            /**
             * 搜索按钮点击事件
             */
            vvlPopoverSearch() {//船名航次航段弹框 搜索按钮点击
                if (this.isVVLSearchClick) {
                    return;
                }
                this.isVVLSearchClick = true;
                this.axios({
                    method: 'post',
                    url: '/api/voyagePlan/getVVLEntity',
                    data: {
                        voyageNo: this.vvlSearch.voyageNo,
                        voyageLeg: this.vvlSearch.voyageLeg,
                        vesselName: this.vvlSearch.vesselName,
                        vesselCode: this.vvlSearch.vesselCode,
                        pageNum: this.vvlSearch.popPageNum,
                        pageSize: this.vvlSearch.popPageSize
                    },
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        this.tablePopoverVVLInfo = response.data.object.list;
                        this.vvlSearch.popTotal = response.data.object.total;
                    } else {
                        this.showMessage(false, this.responseCode, "error");
                    }
                    this.isVVLSearchClick = false;
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                    this.isVVLSearchClick = false;
                });
                //每次查询结束清空tablePopoverVVLSelection
                this.tablePopoverVVLSelection = [];
            },
            /**
             * 确认按钮点击事件
             */
            vvlPopoverConfirm() {//确认按钮点击,赋值选中记录的船名和航次到VVL查询输入框中
                if (this.tablePopoverVVLSelection.length !== 0) {//获取弹框中最后选中的记录
                    this.vvlPopTableRowDbClick(this.tablePopoverVVLSelection[0]);
                }
                this.$refs.tablePopoverVVLInfo.showPopper = false;
                this.resetVVLPopTableData();
            },
            /**
             * 关闭按钮点击事件
             */
            vvlPopoverClose() {
                this.$refs.tablePopoverVVLInfo.showPopper = false;
                this.resetVVLPopTableData();
            },
            /**
             * 船名航次弹框数据分页条
             */
            popVVLHandleDemand() {
                this.vvlPopoverSearch();
            },
            popVVLHandleSizeChange(val) {
                this.vvlSearch.popPageSize = val;
                this.popVVLHandleDemand();
                this.$emit("backTop");
            },
            popVVLHandleCurrentChange(val) {
                this.vvlSearch.popPageNum = val;
                this.popVVLHandleDemand();
                this.$emit("backTop");
            },
            /**
             * 船名航次表格行点击击事件
             */
            vvlPopTableRowClick(row) {
                this.tablePopoverVVLSelection = [row];
            },
            /**
             * 船名航次表格行双击事件（某行被双击时,自动关闭弹框,获取该行船名航次数据,赋值船名航次输入框）
             */
            vvlPopTableRowDbClick(row) {
                this.invoiceDoc.vesselCode = row.vesselCode;
                this.invoiceDoc.voyageNo = row.voyageNo;
                this.invoiceDoc.voyageLeg = row.voyageLeg;
                this.$refs.tablePopoverVVLInfo.showPopper = false;
                this.resetVVLPopTableData();
            },
            resetVVLPopTableData() {
                // 清空已查询出来的船名航次信息
                this.tablePopoverVVLInfo = [];
                // 清空选中船名航次信息
                this.tablePopoverVVLSelection = [];
                this.vvlSearch.popTotal = 0;
            },

            /************************************ 其他事件 *************************************/
            /**
             * Tab页点击切换事件
             */
            handleClick(tab, event) {
                console.log(tab, event);
            },
            /**
             * 下拉控件国际化显示 公共方法
             */
            getDisplayValue(item) {
                return localStorage.getItem('locale') == 'en' ? item.displayValue : item.displayValueCn;
            },
            /**
             * 显示数字格式化
             */
            formatNumber(number, decimals) {
                if (number != null && number !== "") {
                    let formatNumber = "";
                    //去掉非法字符
                    number = (number + '').replace(/[^\d.]/g, '')
                    // 必须保证第一个为数字而不是. 输入第一位为.默认补充0
                        .replace(/^\./g, '0.')
                        // 保证只有出现一个.而没有多个.
                        .replace(/\.{2,}/g, '.')
                        // 保证.只出现一次，而不能出现两次以上
                        .replace('.', '$#$')
                        .replace(/\./g, '')
                        .replace('$#$', '.');
                    let strs = number.split('.');
                    if (strs.length === 1) {
                        formatNumber = strs[0]+".00";
                    } else if (strs.length > 1) {
                        strs[1] += "00";
                        if (strs[1].length > decimals) {
                            strs[1] = strs[1].substring(0, decimals);
                        }
                        formatNumber = strs.join('.');
                    }
                    return formatNumber;
                } else {
                    return "0.00";
                }
            },
            /**
             * 获取发票状态
             */
            getInvoiceStatusDisplay(data){
                let value = {};
                this.isCancelledOptions.forEach((option) => {
                    if (option.codeValue == data.isCancelled) {
                        value = option;
                    }
                });

                if (value !== {}) {
                    return localStorage.getItem('locale') == 'en' ? value.displayValue : value.displayValueCn;
                } else {
                    return data.isCancelled;
                }
            },
            /**
             * 页面刷新（公共方法）
             */
            refreshPage() {
                // 还原按钮控制状态
                this.isSaveClick = false;
                this.isVVLSearchClick = false;
            },
            updateTotalAmount(val) {
                // 获取修改之前的值
                const monthPreValue = this.$refs.rateMonthSelect.value;
                const currencyPreValue = this.$refs.currencySelect.value;

                // 校验发票币种是否为空
                if(this.invoiceDoc.currency == null || this.invoiceDoc.currency == ""){
                    this.invoiceDoc.rateMonth = monthPreValue;// 恢复月份原值
                    this.invoiceDoc.currency = currencyPreValue;// 恢复开票币种原值
                    this.showMessage(false, "合计金额 币种 不能为空！请选择", "warning");
                    return;
                }
                // 校验付款月份是否为空
                if(this.invoiceDoc.rateMonth == null || this.invoiceDoc.rateMonth == ""){
                    this.invoiceDoc.rateMonth = monthPreValue;// 恢复月份原值
                    this.invoiceDoc.currency = currencyPreValue;// 恢复开票币种原值
                    this.showMessage(false, "付款月份 不能为空！请选择", "warning");
                    return;
                }

                // 重新查询汇率并更新发票内容
                this.axios({
                    method: 'post',
                    url: '/api/invoiceDoc/updateDetailsByCurrencyAndMonth',
                    data: this.returnCondition(),
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(response => {
                    this.responseCode = response.data.backMessage;
                    if (response.data.backCode === "200") {
                        let invoiceDoc = response.data.object;
                        // 更新页面发票内容
                        this.setFieldValue(invoiceDoc);
                    } else {
                        this.invoiceDoc.rateMonth = monthPreValue;// 恢复月份原值
                        this.invoiceDoc.currency = currencyPreValue;// 恢复开票币种原值
                        this.showMessage(false, this.responseCode, "error");
                    }
                }).catch(error => {
                    this.invoiceDoc.rateMonth = monthPreValue;// 恢复月份原值
                    this.invoiceDoc.currency = currencyPreValue;// 恢复开票币种原值
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },

            /************************************ 页面数据初始化 ************************************/
            /**
             * 页面数据初始化（入口方法）
             */
            initPageInfo() {
                // if (this.$route.params == null) {
                //     return;
                // }
                // if (this.$route.params.invoiceDocInfo == null) {
                //     return;
                // }
                // // 获取路由传递发票信息
                // let invoiceDocInfo = this.$route.params.invoiceDocInfo;
                if(sessionStorage.getItem("PASSING_PARAMETERS") == null){
                    return;
                }
                let invoiceDocInfo = JSON.parse(sessionStorage.getItem("PASSING_PARAMETERS"));

                // 由对账单明细页面跳转过来时需记录对账信息
                // if(this.$route.params.statementOfAccounts != null){
                //     this.statementOfAccountList = this.$route.params.statementOfAccounts;
                if(sessionStorage.getItem("PASSING_PARAMETERS_1") != null){
                    this.statementOfAccountList = JSON.parse(sessionStorage.getItem("PASSING_PARAMETERS_1"));
                    // 新增发票默认为非电子发票
                    invoiceDocInfo.electronicInvoiceFlag = 0;
                    // 获取当前登录账号信息是否电票标志
                    let custC= JSON.parse (sessionStorage.getItem("CUSTOMER"));
                    if (custC != null && custC.electronicInvoiceFlag != null){
                        invoiceDocInfo.electronicInvoiceFlag = custC.electronicInvoiceFlag
                    }
                    // 新增发票默认为未提交状态
                    invoiceDocInfo.isCancelled = 0;
                    this.updateInoviceTypeOpyions(invoiceDocInfo.electronicInvoiceFlag);
                    this.setFieldValue(invoiceDocInfo);
                } else{
                    // 由发票查询页面跳转过来，需根据发票id获取到最新数据
                    this.axios({
                        method: 'post',
                        url: '/api/invoiceDoc/invoiceDocDetailsQuery/'+invoiceDocInfo.invoiceDocId,
                        headers: {
                            'Accept-language': localStorage.getItem("locale")
                        }
                    }).then(response => {
                        this.responseCode = response.data.backMessage;
                        if (response.data.backCode === "200") {
                            this.setFieldValue(response.data.object);
                        } else {
                            this.showMessage(false, this.responseCode, "error");
                        }
                    }).catch(error => {
                        if (error.data) {
                            this.responseCode = error.data.backMessage;
                            this.showMessage(false, this.responseCode, "error");
                        } else {
                            this.showMessage(false, error, "error");
                        }
                    });
                }

                this.$nextTick(() => {//等待页面渲染好之后再调用，否则获取不到this.refs
                    this.refreshPage();
                });
            },
            setFieldValue(data) {
                // 清空页面数据，重新赋值
                this.tableInvoiceBLInfo = [];
                this.tableInvoiceFreightInfo = [];

                // 赋值发票基本内容
                this.invoiceDoc = data;
                // 赋值电子发票标志
                if(data.electronicInvoiceFlag != null && data.electronicInvoiceFlag == 1){
                    this.invoiceDoc.electronicInvoiceFlag = true;
                } else{
                    this.invoiceDoc.electronicInvoiceFlag = false;
                }

                // 赋值发票收费内容
                if(data.invoiceDocChargingVo != null){
                    let chargingContent = data.invoiceDocChargingVo;
                    this.invoiceDoc.businessNo = chargingContent.businessNo;
                    this.invoiceDoc.freightName = chargingContent.freightName;
                    this.invoiceDoc.quantity = chargingContent.quantity;
                    this.invoiceDoc.unitPrice = chargingContent.unitPrice;
                    this.invoiceDoc.currency = chargingContent.currency;
                    this.invoiceDoc.settleAmount = chargingContent.settleAmount;
                    this.invoiceDoc.remark = chargingContent.remark;
                    this.invoiceDoc.totalAmount = chargingContent.totalAmount;
                    this.invoiceDoc.totalSay = chargingContent.totalSay;
                }

                // 【赋值发票提单号数据】
                if(data.invoiceDocBlFreightVos != null && data.invoiceDocBlFreightVos.length > 0){
                    this.tableInvoiceBLInfo = data.invoiceDocBlFreightVos;
                }

                // 【赋值费用明细表格】
                if(data.invoiceDocDetailVos != null && data.invoiceDocDetailVos.length > 0){
                    this.tableInvoiceFreightInfo = data.invoiceDocDetailVos;
                }

                // 复制发票状态
                Watermark.set(this.getInvoiceStatusDisplay(data), this.$refs.container);
            },

            /************************************ 基础数据下拉框赋值 ************************************/
            /**
             * 币种下拉选赋值
             */
            currencyCodeFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/codedict/getCurrencyCodeList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.currencyOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 港口下拉选赋值
             */
            portFocus() {
                const _this = this;
                this.axios({
                    method: "get",
                    url: "/api/port/getAllPortList",
                    headers: {
                        'Accept-language': localStorage.getItem("locale")
                    }
                }).then(function (response) {
                    _this.portOptions = response.data.object
                }).catch(error => {
                    if (error.data) {
                        this.responseCode = error.data.backMessage;
                        this.showMessage(false, this.responseCode, "error");
                    } else {
                        this.showMessage(false, error, "error");
                    }
                });
            },
            /**
             * 获取开票状态显示值
             */
            getInvoiceStatusDisplayValue(invoiceStatus) {
                let displayValue = invoiceStatus;
                try {
                    if (invoiceStatus !== "") {
                        this.invoiceStatusOptions.forEach((item) => {
                            if (item.codeValue === invoiceStatus) {
                                displayValue = this.getDisplayValue(item);
                                throw new Error("EndForEach");
                            }
                        })
                    }
                } catch (error) {
                    if (error.message === "EndForEach") {
                        return displayValue;
                    } else {
                        this.showMessage(false, error, "error");
                    }
                }
            },
            /**
             * 获取核销状态显示值
             */
            getAllocatedStatusDisplayValue(allocatedStatus) {
                let displayValue = allocatedStatus;
                try {
                    if (allocatedStatus !== "") {
                        this.allocatedStatusOptions.forEach((item) => {
                            if (item.codeValue === allocatedStatus) {
                                displayValue = this.getDisplayValue(item);
                                throw new Error("EndForEach");
                            }
                        })
                    }
                } catch (error) {
                    if (error.message === "EndForEach") {
                        return displayValue;
                    } else {
                        this.showMessage(false, error, "error");
                    }
                }
            },
            /**
             * 电子发票勾选状态改变时更新发票类型可选选项集合
             */
            updateInoviceTypeOpyions(val){
                // 电子发票勾选状态改变时自动清空发票类型
                this.invoiceDoc.invoiceType = "";
                if(val){
                    // 勾选电子发票，设置发票类型可用 电普、全电
                    this.invoiceTypeOptions = [
                        {codeValue: "DP", displayValueCn: "电普", displayValue: "ELECTRIC ORDINARY"},
                        {codeValue: "QD", displayValueCn: "全电", displayValue: "ALL ELECTRIC"}
                    ];
                }else{
                    // 非电子发票， 设置发票类型可用 纸普、形式
                    this.invoiceTypeOptions = [
                        {codeValue: "ZP", displayValueCn: "纸普", displayValue: "PAPER ORDINARY"},
                        {codeValue: "XS", displayValueCn: "形式", displayValue: "PROFORMA"}
                    ];
                }
            },
        },
        mounted() {
        },
        created() {
            /**
             * 页面创建完成后初始化页面数据
             */
            this.initPageInfo();
            /**
             * 调用父页面更新右上角用户信息方法
             */
            this.$parent.updateHeaderAside();
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../assets/scss/base";
    @import "../../../assets/scss/public";

    .el-row {
        margin-bottom: 0;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .el-col {
        margin-bottom: 0;
        border-radius: 4px;
    }

    .inputName-left {
        flex: 1;
        margin: 0 5px;
    }

    .packageTypeButton {
        width: 25px;
        height: 25px;
        margin-top: 2px;
    }

    .cardBox {
        background: $colorA;
        margin-bottom: 20px;
        border: 1px solid #e8e8e8;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        padding: 16px 16px 1px 16px;
    }

    .lastCardBox {
        width: 59.5%;
        margin-right: 0.5%;
        height: 80px;
    }

    .lastCardBox2 {
        width: 59.5%;
        height: 80px;
    }

    .cardTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .cardTitle2 {
        margin-top: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .collapseTitle {
        margin-bottom: 10px;

        span {
            font-size: $fontE;
            color: rgba(0, 0, 0, 0.85);
            letter-spacing: 0;
            font-weight: 600;
            margin-left: 6px;
        }
    }

    .collapseItem {
        margin-top: -16px;
    }

    .setting {
        justify-content: flex-start;

        ul {
            li {
                margin-right: 15px;
                color: #6d7278;
                font-size: $fontB;
            }
        }
    }

    /*给el-table滚动条设置宽度和高度*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 10px; // 横向滚动条
        height: 10px; // 纵向滚动条 必写
    }

    .position-right {
        height: 20px;
        text-align: right;
    }

    .topMargin {
        margin-top: 20px;
    }

    .popoverInner {
        margin: 5px;
        margin-top: 0;
    }

    .inputName-title-left-textarea3 {
        height: 52px;
        line-height: 53px;
    }

    /deep/ .el-collapse-item__header {
        padding: 16px 16px 1px 16px;
    }

    /deep/ .el-collapse-item__content {
        padding: 16px 16px 1px 16px;
    }

    /deep/ .el-icon-arrow-right {
        border-radius: 50%;
        border: 2px solid #e8e8e8;
        color: #2867ce;
        font-size: $fontE;
        font-weight: 600;
    }

    .el-image.el-image__error {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        background: #F5F7FA;
        color: #C0C4CC;
        vertical-align: middle;
    }

    ::v-deep .el-tabs__content {
        background: #fff;
        padding: 0 0;
    }

    .inputName {
        flex: 1;
        margin: 2px 5px;
    }

    //重写el-input样式，只显示下边框
    .inputName ::v-deep.el-input__inner{
        border-radius: 0;// 去掉圆角
        border-left-width: 0;
        border-right-width: 0;
        border-top-width: 0;
        border-bottom-width: 1px;//只显示下边框
    }

    .inputName ::v-deep.el-input.is-disabled .el-input__inner {
        background-color: #FFFFFF;
        border-color: #E4E7ED;
        color: black;
        cursor: not-allowed;
    }

    .voyageIcon {
        margin-left: 10px;
        margin-top: 5px;
        width: 25px;
        height: 25px;
        border: 1px solid #0091ff;
        border-radius: 4px;
    }

    .boatBox {
        position: relative;

        .boatBox-list-box {
            min-width: 280px;
            position: absolute;
            left: 51px;
            top: 30px;
            background: $colorA;
            padding: 5px 10px;
            z-index: 100;
            border: 1px solid $colorE;
            font-size: $fontC;
            font-weight: 600;

            .boatBox-top {
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: $colorB;
            }

            .left {
                width: 30%;
                margin-right: 4%;
            }

            .right {
                width: 66%;
            }

            ul {
                padding: 0;
                margin: 0;

                li {
                    border-bottom: 1px solid #e7f0fc;
                    padding: 4px 2px;
                }

                li:last-of-type {
                    border: none;
                }

                li:hover {
                    background: rgb(224, 240, 245);
                }
            }
        }
    }

</style>
<style lang="scss">
    .el-tabs__content {
        background: #fff;
    }
</style>